import Users from './Users'
import Advertisers from './Advertisers'
import Agencies from './Agencies'
import Notifications from './Notifications'
import Files from './Files'
import Locations from './Locations'
import Errors from './Errors'
import Previews from './Previews'

export default {
  Users,
  Advertisers,
  Agencies,
  Notifications,
  Files,
  Locations,
  Errors,
  Previews
}
